import { createIsomorphicFn } from "@tanstack/react-start";
import {
  setCookie as setServerCookie,
  getCookie as getServerCookie,
} from "@tanstack/react-start/server";
import Cookies from "js-cookie";
import ms, { type StringValue } from "ms";

type TSetCookieOptions = {
  /*
   * "ms" supported string or number of milliseconds
   */
  expires?: StringValue | number;
};

const convertCookieExpiresToDate = (
  value: TSetCookieOptions["expires"],
): Date | undefined => {
  if (!value) return undefined;
  const normalizedValue = typeof value === "string" ? ms(value) : value;
  return new Date(Date.now() + normalizedValue);
};
export const getCookie = createIsomorphicFn()
  .server(async (name: string) => {
    return getServerCookie(name);
  })
  .client(async (name: string) => {
    return Cookies.get(name);
  });
export const setCookie = createIsomorphicFn()
  .server((name: string, value: string, opts?: TSetCookieOptions) => {
    setServerCookie(name, value, {
      expires: convertCookieExpiresToDate(opts?.expires),
    });
  })
  .client((name: string, value: string, opts?: TSetCookieOptions) => {
    Cookies.set(name, value, {
      expires: convertCookieExpiresToDate(opts?.expires),
    });
  });
